import React, { useEffect, useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { NavigationActions } from '@react-navigation/native';
import { t } from 'Locale';
import LinearGradient from 'react-native-linear-gradient';
import { ScrollView, Modal } from 'react-native';

import { Background, Button } from 'LocalGluons';
// import { useStore } from 'Store';
import NoRecordingsContent from 'Pages/Recordings/components/NoRecordingsContent';
import DownloadsList from 'Pages/Downloads/components/DownloadsList';
import EditSelectBar from '../Recordings/components/EditSelectBar';
import styles from './components/DownloadsList/DownloadList.jss';
import DeleteConfirmDialog from './components/DeleteConfirmDialog';

const toggleDlPause = async (id, downloads) => {
    const item = downloads.find((itm) => itm.id === id);
    if (item && item.paused) {
        // await StreamStorageManager.resume(item.id, console.log.bind(console));
    } else {
        // await StreamStorageManager.pause(item.id, console.log.bind(console));
    }
};

// const deleteDl = async (id) => {
//     // await StreamStorageManager.delete(id);
// };

const buttonStyle = {
    button: styles.editButton
};

// mocks

const deleteDl = () => {};

// WARNING
// This component is unused and
// Absolutelly gutted, needs to be revisited in detail when implemented

// eslint-disable-next-line max-statements
const Downloads = ({ navigation }) => {
    // const { appManager } = useStore();
    const [downloads, setDownloads] = useState([]);
    const [isEditing, setEditing] = useState(false);
    const [allCheckbox, setAllCheckbox] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const interval = useRef(null);

    const finishedDownloads = downloads.filter((item) => item && item.progressPercent >= 100);

    const getDownloads = useCallback(async () => {
        const deviceDownloads = [];
        try {
            // deviceDownloads = await appManager.getDownloads();
        } catch (error) {
            console.log(error);
        }
        setDownloads(deviceDownloads);
    }, []);

    interval.current = setInterval(() => {
        getDownloads();
    }, 2000);

    const selectAll = useCallback(() => {
        if (!allCheckbox) {
            setSelectedIds(finishedDownloads.map((item) => item.id));
        } else {
            setSelectedIds([]);
        }
        setAllCheckbox(!allCheckbox);
    }, [downloads, allCheckbox]);

    const startEditing = useCallback(() => {
        setEditing(true);
    }, []);

    const stopEditing = useCallback(() => {
        setEditing(false);
        setAllCheckbox(false);
        setSelectedIds([]);
    }, []);

    const onTvGuidePress = useCallback(() => {
        const navigateAction = NavigationActions.navigate('TvGuide', { routeName: 'TvGuide' });
        navigation.dispatch(navigateAction);
    }, []);

    const togglePause = async (dlId) => {
        await toggleDlPause(dlId, downloads);
        await getDownloads();
    };

    const deleteItemById = useCallback(
        (id) => async () => {
            await deleteDl(id);
            await getDownloads();
        },
        [downloads]
    );

    const displayDeleteDialog = useCallback(() => {
        setShowDeleteDialog(true);
    }, []);

    const deleteDialogCancel = useCallback(() => {
        setShowDeleteDialog(false);
    }, []);

    const deleteDialogConfirm = useCallback(() => {
        selectedIds.forEach((id) => deleteDl(id));
        stopEditing();
        setShowDeleteDialog(false);
        setDownloads([]);
        getDownloads();
    }, [selectedIds]);

    useEffect(() => {
        if (allCheckbox && selectedIds.length !== finishedDownloads.length) {
            setAllCheckbox(false);
        } else if (!allCheckbox && selectedIds.length === finishedDownloads.length) {
            setAllCheckbox(true);
        }
    }, [downloads, selectedIds, allCheckbox]);

    useEffect(() => {
        const init = async () => {
            await getDownloads();
        };

        init();
    }, []);

    let timeoutId = null;
    useEffect(() => {
        // eslint-disable-line consistent-return
        if (downloads.some((dl) => !dl.paused && dl.progressPercent < 100)) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(getDownloads, 600);
        }
        return () => {
            timeoutId = null;
            clearTimeout(timeoutId);
            clearInterval(interval);
        };
    }, [downloads]);

    return (
        <Background>
            {downloads && downloads.length > 0 ? (
                <>
                    <Modal
                        animationType="slide"
                        transparent
                        visible={showDeleteDialog}
                        onRequestClose={deleteDialogCancel}
                    >
                        <DeleteConfirmDialog
                            close={deleteDialogCancel}
                            onDeleteConfirm={deleteDialogConfirm}
                        />
                    </Modal>
                    <EditSelectBar
                        editing={isEditing}
                        allCheckbox={allCheckbox}
                        selectAll={selectAll}
                        startEditing={startEditing}
                    />
                    <ScrollView>
                        <DownloadsList
                            downloads={isEditing ? finishedDownloads : downloads}
                            isEditing={isEditing}
                            selectedIds={selectedIds}
                            setSelectedIds={setSelectedIds}
                            togglePause={togglePause}
                            deleteById={deleteItemById}
                        />
                    </ScrollView>
                    {isEditing && (
                        <LinearGradient
                            style={styles.editButtonContainer}
                            colors={['#00000088', '#000000FF']}
                        >
                            <Button
                                style={buttonStyle}
                                title={t('COMMON.CANCEL')}
                                onPress={stopEditing}
                                isSecondary
                            />
                            <Button
                                style={buttonStyle}
                                title={t('COMMON.DELETE')}
                                onPress={displayDeleteDialog}
                                isDisabled={!selectedIds.length}
                            />
                        </LinearGradient>
                    )}
                </>
            ) : (
                <NoRecordingsContent onTvGuidePress={onTvGuidePress} />
            )}
        </Background>
    );
};

Downloads.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default Downloads;
